import React, { Component } from 'react';

import SalesTiersContainer from '../global/SalesTiers';
import withModal from '../../common/WithModal';

class SalesTiersModal extends Component {
  modal = {
    containerClassName: 'modal-details',
  };

  render() {
    const { appliedTieredSale, open, onClose } = this.props;

    return (
      <span className="details-sales-modal">
        <SalesTiersContainer
          promotion={appliedTieredSale}
          open={open}
          onClose={onClose}
        />
      </span>
    );
  }
}

export default withModal(SalesTiersModal);
